import SEO from "@/components/SEO";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";
import { artistas } from "@/mocks/artistas";
import { albuns } from "@/mocks/albuns";

export default function ArtistaPage() {
  const { artistaId } = useParams<{ artistaId: string }>();
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

  const artista = artistas.find((a) => a.id === artistaId);
  const albunsArtista = albuns.filter((a) => a.artistaId === artistaId);

  if (!artista) {
    return (
      <div className="min-h-screen bg-godoy-black">
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <h1 className="font-serif text-2xl text-godoy-cream">Artista não encontrado</h1>
          <Link to="/biblioteca" className="text-godoy-gold mt-4 inline-block">
            Voltar para Biblioteca
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    name: artista.nome,
    genre: artista.genero,
    url: `${siteUrl}/biblioteca/${artista.id}`,
    description: artista.descricao,
  };

  return (
    <>
      <SEO
        title={`${artista.nome} - Partituras Gospel`}
        description={`Baixe as partituras de ${artista.nome} em PDF. ${artista.descricao || ""} ${artista.albuns} álbuns disponíveis na GodoyProd.`}
        keywords={`${artista.nome}, partituras gospel, partituras PDF, ${artista.genero}`}
        schema={schema}
        canonicalPath={`/biblioteca/${artista.id}`}
      />
      <div className="min-h-screen bg-godoy-black">
        <Navbar />

        <section className="pt-32 pb-20 md:pt-40 md:pb-28">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">
            {/* Header Artista — sem foto */}
            <div className="mb-16">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-godoy-gold/10 border border-godoy-gold/20 flex items-center justify-center">
                  <i className="ri-music-2-line text-godoy-gold text-lg" />
                </div>
                <span className="text-godoy-gold text-sm font-semibold tracking-widest uppercase">
                  {artista.genero}
                </span>
              </div>
              <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-godoy-cream">
                {artista.nome}
              </h1>
              <p className="text-godoy-lightgray mt-3 max-w-xl">
                {artista.descricao}
              </p>
              <div className="flex items-center gap-6 mt-4 text-sm text-godoy-lightgray">
                <span>
                  <strong className="text-godoy-cream">{artista.albuns}</strong> álbuns
                </span>
                <span>
                  <strong className="text-godoy-cream">{artista.musicas}</strong> músicas
                </span>
              </div>
            </div>

            {/* Álbuns — manter cards com imagem de capa */}
            {albunsArtista.length > 0 ? (
              <div>
                <h2 className="font-serif text-2xl md:text-3xl font-bold text-godoy-cream mb-8">
                  Álbuns
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {albunsArtista.map((album) => (
                    <Link
                      key={album.id}
                      to={`/biblioteca/${artista.id}/${album.id}`}
                      className="group bg-godoy-charcoal/60 border border-godoy-gray/30 rounded-lg overflow-hidden hover:border-godoy-gold/40 transition-all"
                    >
                      <div className="aspect-square overflow-hidden">
                        <img
                          src={album.imagem}
                          alt={album.titulo}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-5">
                        <h3 className="font-serif text-lg font-semibold text-godoy-cream group-hover:text-godoy-gold transition-colors">
                          {album.titulo}
                        </h3>
                        <p className="text-sm text-godoy-lightgray mt-1">
                          {album.ano} · {album.musicas} músicas
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <div className="bg-godoy-charcoal/40 border border-godoy-gray/20 rounded-lg p-12 text-center">
                <i className="ri-music-2-line text-5xl text-godoy-gold/30 mb-4" />
                <h2 className="font-serif text-xl font-bold text-godoy-cream mb-2">
                  Em breve partituras disponíveis
                </h2>
                <p className="text-godoy-lightgray max-w-md mx-auto">
                  Estamos trabalhando para trazer as partituras de {artista.nome} para você.
                  Volte em breve!
                </p>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}